export default __webpack_public_path__ + "static/media/about_1.a543cb7f.png";